import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ProviderNotesModel from "../../models/provider-notes";

export default class ProviderNotesRepository extends BaseRepository {
  static modelClass = ProviderNotesModel;
  modelName = "provider-notes";

  async query({ providerId, ...params } = {}, customURLPath = null) {
    try {
      if (!providerId && !customURLPath) {
        throw new Error("providerId is required to fetch provider notes.");
      }

      const queryString = qs.stringify(params);
      const baseUrl = customURLPath ?? `provider/${providerId}/notes/`;

      return await super.query({
        urlPath: queryString ? `${baseUrl}?${queryString}` : baseUrl,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async patch(id, params, providerId) {
    try {
      if (!id) {
        throw new Error("Note id is undefined or null");
      }
      if (!providerId) {
        throw new Error("providerId is undefined or null");
      }

      return await super.patch(id, params, {
        urlPath: `provider/${providerId}/update_note/${id}/`,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async createRecord(providerId, data) {
    try {
      if (!providerId) {
        throw new Error("providerId is undefined or null");
      }

      return await super.createRecord(data, {
        urlPathWithQueryParams: `provider/${providerId}/add_note/`,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async delete(id, providerId) {
    try {
      if (!id) {
        throw new Error("Note id is undefined or null");
      }
      if (!providerId) {
        throw new Error("providerId is undefined or null");
      }

      return await super.delete(id, {
        urlPath: `provider/${providerId}/delete_note/${id}/`,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
